import moment from 'moment'
import { faqActions } from '../../actions'
import { userinfoConstants } from '../../constants'
import axios from 'axios'
import { uriConstants } from '../../../store/constants';
const initialState = {
  data: {},
  address: {},
  status: [],
  isLoading: false,
  isFailure: false,
  isCalled: false,
  isSearch: false,
  isUpdate: false,
  isInactive: false,
  isRetire: false,
  // 비밀번호 3개월 변경
  isRequirePassChange: false,
  deviceId: '',
  snsInfoList: [],
  signData:'',
}

export default function userinfo(state = initialState, action) {
  switch (action.type) {
    /*********
         사용자 초기정보 조회
         **********/
    case userinfoConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case userinfoConstants.LOAD_SUCCESS:
      // console.log('오늘로부터 3개월 전 = ', moment().subtract(3, 'month').format('YYYYMMDD'));
      // console.log('마지막수정날짜 = ', moment(action.response.data?.payload?.modDt).format('YYYYMMDD'));

      // 현재날짜
      // moment().format('YYYYMMDD');

      // // 마지막 수정일 + 3개월
      // moment(action.response.data?.payload?.modDt).add(3, 'M').format('YYYYMMDD');

      // console.log('오늘날짜 = ', moment().format('YYYYMMDD'));
      // console.log('==== = ', action.response.data?.payload);

      // console.log('마지막수정날짜 + 3개월 후 = ', moment(action.response.data?.payload?.passwdModDt).add(3, 'M').format('YYYYMMDD'));
      // console.log('userinfo.LOAD_SUCCESS:', action.response.data?.payload)
      return {
        ...state,
        data: action.response.data?.payload,
        isUpdate: false,
        isSearch: true,
        isInactive: false,
        //isRequirePassChange: action.response.data?.payload?.modDt > 0 && moment().subtract(3, 'month').format('YYYYMMDD') >= moment(action.response.data?.payload?.modDt).format('YYYYMMDD')
        isRequirePassChange:
          action.response.data?.payload?.passwdModDt > 0 &&
          moment().format('YYYYMMDD') > moment(action.response.data?.payload?.passwdModDt).add(3, 'M').format('YYYYMMDD'),
      }
    case userinfoConstants.LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    /*********
         사용자 정보변경
         **********/
    case userinfoConstants.UPDATE_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case userinfoConstants.UPDATE_SUCCESS:
      return {
        ...state,
        data: action.response.data?.payload,
        isUpdate: true,
      }
    case userinfoConstants.UPDATE_FAILURE:
      return {
        isLoading: false,
        isUpdate: false,
      }

    /*********
         비밀번호 변경
         **********/
    case userinfoConstants.PASSWORD_REQUEST:
      return {
        ...state,
      }
    case userinfoConstants.PASSWORD_SUCCESS:
      return {
        ...state,
        isUpdatePass: true,
      }
    case userinfoConstants.PASSWORD_FAILURE:
      return {
        ...state,
        isUpdatePass: false,
      }

    /*********
         주소 갱신
         **********/
    case userinfoConstants.CHANGE_ADDRESS:
      return {
        ...state,
        address: action.addressObj,
      }

    /*********
         회원탈퇴
         **********/
    case userinfoConstants.RETIRE_REQUEST:
      return {}
    case userinfoConstants.RETIRE_SUCCESS:
      return {
        ...state,
        isRetire: true,
      }
    case userinfoConstants.RETIRE_FAILURE:
      return {
        ...state,
        isRetire: false,
      }

    /*********
         휴면설정
         **********/
    case userinfoConstants.INACTIVE_REQUEST:
      return {}
    case userinfoConstants.INACTIVE_SUCCESS:
      return {
        ...state,
        isInactive: true,
      }
    case userinfoConstants.INACTIVE_FAILURE:
      return {
        isFailure: true,
      }

    case userinfoConstants.SET_DEVICE_ID:
      // console.log("action.deviceId = = > " , action.deviceId);
      return {
        ...state,
        deviceId: action.deviceId,
      }
    /*********
         소셜로그인
         **********/
    case userinfoConstants.SNSINFO_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case userinfoConstants.SNSINFO_LOAD_SUCCESS:
      return {
        ...state,
        snsInfoList: action.response.data?.payload,
      }
    case userinfoConstants.SNSINFO_LOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    /*********
         소셜로그인 연동해제
         **********/
    case userinfoConstants.DELETE_SNSINFO_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case userinfoConstants.DELETE_SNSINFO_SUCCESS:
      return {
        ...state,
        snsInfoList: action.response.data?.payload,
      }
    case userinfoConstants.DELETE_SNSINFO_FAILURE:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
      }
    case userinfoConstants.SET_SIGNDATA:
    return {
      ...state,
      signData: action.signData
    }
    default:
      return state
  }
}
